var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXtwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.85714 1.4375C1.28125 1.4375 0 2.72676 0 4.3125V18.6875C0 20.2732 1.28125 21.5625 2.85714 21.5625H17.1429C18.7188 21.5625 20 20.2732 20 18.6875V4.3125C20 2.72676 18.7188 1.4375 17.1429 1.4375H2.85714ZM16.1205 5.21094L11.4866 10.5387L16.9375 17.7891H12.6696L9.33036 13.3912L5.50446 17.7891H3.38393L8.33929 12.0885L3.11161 5.21094H7.48661L10.5089 9.23145L14 5.21094H16.1205ZM14.433 16.5133L6.84821 6.41934H5.58482L13.2545 16.5133H14.4286H14.433Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXtwitter);
export default __webpack_public_path__ + "static/media/xtwitter.671acfa577c9e2decdb876921f5a9356.svg";
export { ForwardRef as ReactComponent };